import apiClient from '@/services/axios'

export async function get(masterId) {
  var response = await apiClient.get(process.env.VUE_APP_CRM_API_BASE_URL + '/VenueCampaigns/ByMasterCampaign/' + masterId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get venue campaigns')
}
